"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveNewUserAccountData = saveNewUserAccountData;
exports.fetchStaffMemberRow = fetchStaffMemberRow;
exports.putRowIntoList = putRowIntoList;
exports.makeUserAddNewHandler = makeUserAddNewHandler;
exports.UserAddNewModalButton = UserAddNewModalButton;
const react_1 = __importDefault(require("react"));
const RepositoryReact_1 = __importDefault(require("../../../React/RepositoryReact"));
const GeneralModalButtons_1 = require("../../../View/Modals/GeneralModalButtons");
const personsV2Helpers_1 = require("../../../Persons/personsV2Helpers");
const StaffMembersController_1 = require("../StaffMembersController");
const UserModalBody_1 = require("./UserModalBody");
const UserValidationSchema_1 = require("./UserValidationSchema");
/**
 * Domknięcie zapisu: konto, potem przypisania projektów.
 *
 * Zwraca błędy zamiast rzucać - wywołujący musi najpierw dopisać wiersz do listy (osoba
 * JEST już w bazie), a dopiero potem pokazać, czego nie zapisał. Rzucenie tutaj zostawiłoby
 * ekran bez nowego wiersza i z wrażeniem, że nic się nie stało.
 */
async function saveNewUserAccountData(person) {
    if (!person?.id)
        return { account: null, errors: [] };
    const errors = [];
    const v2Result = await (0, personsV2Helpers_1.savePersonV2AccountAndProfile)(person.id, (0, personsV2Helpers_1.buildAccountPayload)(person), {}, "StaffMembers");
    errors.push(...v2Result.errors);
    try {
        await (0, personsV2Helpers_1.saveProjectAssignments)(person);
    }
    catch (error) {
        errors.push(`Przypisania projektów: ${error instanceof Error ? error.message : String(error)}`);
    }
    return { account: v2Result.account, errors };
}
/**
 * Wiersz listy dla świeżo założonej osoby - czytany z serwera, nie składany z formularza.
 *
 * Powód: zapis konta z rolą 1/2/3/6/7 zakłada po drodze wiersz uprawnień z DOMYŚLNYMI
 * flagami roli (`StaffMemberRepository.ensureDefaultsForRole`), więc wiersz złożony
 * z formularza pokazywałby same zera i kłamał o stanie bazy.
 *
 * Osobne, tymczasowe repozytorium: `loadItemsFromServerPOST` podmienia `items` w całości,
 * więc odczyt na repozytorium listy skasowałby jej zawartość. `skipCache`, żeby jednoelementowy
 * wynik nie wylądował w sessionStorage pod cudzym kluczem.
 */
const newUserRowRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "admin/staffMembers",
        addNewRoute: "",
        editRoute: "",
        deleteRoute: "",
    },
    name: "staffMembers_newUserRow_temp",
});
async function fetchStaffMemberRow(personId) {
    // scope „all": osoba bez e-maila systemowego i bez wiersza flag nie mieści się
    // w domyślnym zakresie listy, a i tak ma się pokazać po dodaniu.
    const rows = (await newUserRowRepository.loadItemsFromServerPOST([{ personId, scope: "all" }], undefined, {
        skipCache: true,
    }));
    return rows?.[0] ?? null;
}
/** Wstawia wiersz do listy okna: podmienia istniejący albo dokłada nowy. */
function putRowIntoList(row) {
    const isAlreadyThere = StaffMembersController_1.staffMembersRepository.items.some((item) => item.id === row.id);
    // Podmiana, nie drugi wiersz: po nieudanym domknięciu (np. zajęty e-mail systemowy)
    // modal zostaje otwarty, a ponowne „Zatwierdź" wchodzi tu drugi raz z tą samą osobą.
    if (isAlreadyThere)
        StaffMembersController_1.staffMembersRepository.replaceItemById(row.id, row);
    else
        StaffMembersController_1.staffMembersRepository.items.push(row);
    StaffMembersController_1.staffMembersRepository.currentItems = [row];
    StaffMembersController_1.staffMembersRepository.saveToSessionStorage();
}
/**
 * Handler `onAddNew`, wyciągnięty z komponentu, żeby dało się go testować.
 *
 * `createdPerson` to odpowiedź `POST /person` scalona z formularzem (`GeneralModal`),
 * więc niesie i numer nowej osoby, i pola konta, których serwer nie zapisał.
 */
function makeUserAddNewHandler(onAddNew) {
    return async function handleAddNew(createdPerson) {
        const { errors } = await saveNewUserAccountData(createdPerson);
        // Odczyt wiersza jest częścią pokazania wyniku, nie zapisem - jego błąd nie może
        // przykryć błędu zapisu konta ani wywrócić modala. Bez wiersza lista po prostu
        // pokaże nową osobę po następnym „Szukaj”.
        let row = null;
        try {
            if (createdPerson?.id)
                row = await fetchStaffMemberRow(createdPerson.id);
        }
        catch (error) {
            console.warn("StaffMembers: nie udało się odczytać wiersza nowego użytkownika: %o", error);
        }
        if (row)
            putRowIntoList(row);
        // Lista czyta `repository.items`, więc argument callbacku jest tu tylko formalnością.
        onAddNew((row ?? createdPerson));
        // Dopiero teraz błąd: modal zostaje otwarty i pokazuje, czego NIE zapisał.
        (0, personsV2Helpers_1.throwOnSaveErrors)(errors);
    };
}
function UserAddNewModalButton({ modalProps: { onAddNew } }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: makeUserAddNewHandler(onAddNew),
            ModalBodyComponent: UserModalBody_1.UserModalBody,
            modalTitle: "Dodaj użytkownika",
            repository: StaffMembersController_1.newUserRepository,
            makeValidationSchema: UserValidationSchema_1.makeUserValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj użytkownika",
            buttonVariant: "outline-success",
        } }));
}
